import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
} from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  content: string;
  onClose: (confirmed: boolean) => void;
  isLoading?: boolean;
  confirmText?: string;
  loadingText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  content,
  onClose,
  isLoading = false,
  confirmText = "Confirm",
  loadingText = "Deleting...",
}) => {
  const handleClose = (confirmed: boolean) => {
    if (!isLoading) {
      onClose(confirmed);
    }
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle color={"red"}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => handleClose(false)} 
          color="inherit"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button 
          onClick={() => handleClose(true)} 
          color="error" 
          autoFocus
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isLoading ? loadingText : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
